module.exports = {
  install: function(Vue, options) {
    const component = {
      name: 'Snackbar',
      model: {
        prop: 'text',
        event: 'change'
      },
      props: ['text'],
      data: () => ({
        visible: false,
        timeoutHandler: null
      }),
      watch: {
        text(val) {
          if (val) {
            this.visible = true;
            if (this.timeoutHandler) clearTimeout(this.timeoutHandler);
            this.timeoutHandler = setTimeout(() => {
              this.$emit('change', null);
              this.visible = false;
            }, 3000);
          }
        }
      },
      template: `<v-snackbar :timeout="0" :bottom="true" v-model="visible">{{ text }}</v-snackbar>`
    };
    Vue.component('toast', component);
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/luffanet-web-components/Toast.js
// module id = rWKl
// module chunks = 0